import type { ReactElement } from 'react';
import type { ChannelDto } from '@gr/core/distribution/channels/dto';
import type { PostDto } from '@gr/core/content/posts/dto';
import { useServices, useT } from '../../../app/di';
import { Card } from '../../../ui-kit/Card/Card';
import { useBlog } from '../../accounts/workspaces';
import { VariantsEditor } from './VariantsEditor/VariantsEditor';

// POST-UC-4, POST-UC-4.CC-1
export function VariantsPanel({ post, channels, editable, onChanged }: { post: PostDto; channels: readonly ChannelDto[]; editable: boolean; onChanged(post: PostDto): void }): ReactElement {
  const { api } = useServices();
  const { t } = useT();
  const { blog } = useBlog();
  return (
    <Card title={t('posts.variants.title')}>
      {channels.length === 0 ? (
        <p className="u-muted">{t('posts.variants.noChannels')}</p>
      ) : (
        <VariantsEditor
          channels={channels}
          variants={post.variants}
          editable={editable}
          onSave={async (channelId, body) => {
            const result = await api.posts.setVariant(blog.id, post.id, channelId, body);
            if (result.success) onChanged(result.data);
            return result;
          }}
        />
      )}
    </Card>
  );
}
